interface IPlatforms {
  id: number;
  label: string;
  image: string;
  faqUrl: string;
  type: enTypePlatform;
  hasCampaign: boolean;
  hasPrice: boolean;
  hasBankslipPurchase: boolean;
}

export enum enTypePlatform {
  FACEBOOK = 'facebook',
  GOOGLE_ANALYTICS = 'google',
  GOOGLE_ANALYTICSG4 = 'googleG4',
  TIKTOK = 'tiktok',
  TAGMANAGER = 'tagmanager',
  ADWORDS = 'adwords',
  HUBSPOT = 'hubspot'
}

const Platforms: IPlatforms[] = [
  {
    id: 1,
    type: enTypePlatform.GOOGLE_ANALYTICS,
    label: 'ID do Google Analytics',
    image: '/img/brands/analytics.png',
    faqUrl: 'https://ajuda.eduzz.com/hc/pt-br/articles/4402739831707-Como-integrar-o-Google-Analytics-%C3%93rbita-',
    hasCampaign: true,
    hasPrice: true,
    hasBankslipPurchase: false
  },
  {
    id: 8,
    type: enTypePlatform.GOOGLE_ANALYTICSG4,
    label: 'ID do Google Analytics G4',
    image: '/img/brands/analyticsG4.png',
    faqUrl: 'https://ajuda.eduzz.com/hc/pt-br/articles/4402739831707-Como-integrar-o-Google-Analytics-%C3%93rbita-',
    hasCampaign: true,
    hasPrice: true,
    hasBankslipPurchase: false
  },
  {
    id: 2,
    type: enTypePlatform.FACEBOOK,
    label: 'ID do Pixel do Facebook',
    image: '/img/brands/facebook.png',
    faqUrl: 'https://ajuda.eduzz.com/?article=como-configurar-o-pixel-do-facebook-orbita',
    hasCampaign: true,
    hasPrice: true,
    hasBankslipPurchase: true
  },
  {
    id: 9,
    type: enTypePlatform.TIKTOK,
    label: 'ID do TikTok ADS Manager',
    image: '/img/brands/tiktok.png',
    faqUrl: '',
    hasCampaign: true,
    hasPrice: true,
    hasBankslipPurchase: false
  },
  {
    id: 3,
    type: enTypePlatform.TAGMANAGER,
    label: 'ID do Google Tag Manager',
    image: '/img/brands/tagmanager.png',
    faqUrl: 'https://ajuda.eduzz.com/hc/pt-br/articles/4402730977563-Como-ativar-o-Google-Tag-Manager-%C3%93rbita-',
    hasCampaign: false,
    hasPrice: false,
    hasBankslipPurchase: false
  },
  {
    id: 4,
    type: enTypePlatform.ADWORDS,
    label: 'ID de Adsense',
    image: '/img/brands/img-awords.png',
    faqUrl:
      'https://ajuda.eduzz.com/hc/pt-br/articles/4403266289307-Como-fa%C3%A7o-para-configurar-o-Pixel-do-Google-Ads-%C3%93rbita-',
    hasCampaign: true,
    hasPrice: true,
    hasBankslipPurchase: true
  },
  {
    id: 7,
    type: enTypePlatform.HUBSPOT,
    label: 'ID do Hubspot',
    image: '/img/brands/hubspot.png',
    faqUrl:
      'https://ajuda.eduzz.com/hc/pt-br/articles/4403006415643-Connect-Como-fazer-a-Integra%C3%A7%C3%A3o-HubSpot-%C3%93rbita-',
    hasCampaign: false,
    hasPrice: false,
    hasBankslipPurchase: false
  }
  //TODO retirado pois não esta liberado no sun
  // {
  //   id: 5,
  //   type: 'taboola',
  //   label: 'ID do Taboola',
  //   image: '/img/brands/taboola.png',
  //   hasCampaign: false,
  //   hasPrice: true
  // },
  // {
  //   id: 6,
  //   type: 'outbrain',
  //   label: 'ID do Outbrain',
  //   image: '/img/brands/outbrain.png',
  //   hasCampaign: false,
  //   hasPrice: true
  // },
];

export default Platforms;
